import React, { useState, useRef, useEffect } from "react";
import setInputValue from "../hooks/useInputValue";
import "../assets/styles/components/HorizontalFormContact.sass";

const HorizontalFormContact = () => {
  const formButton = document.getElementById("horizontal-form__button");
  const formInputs = document.getElementById("horizontal-form");
  const formLoadTime = useRef(Date.now());
  const [hasInteracted, setHasInteracted] = useState(false);

  let name = setInputValue("");
  let email = setInputValue("");
  let phone = setInputValue("");
  let message = setInputValue("");
  let website = setInputValue(""); // Honeypot field

  // Track user interaction to detect bots
  useEffect(() => {
    const handleInteraction = () => setHasInteracted(true);
    window.addEventListener('mousemove', handleInteraction, { once: true });
    window.addEventListener('keydown', handleInteraction, { once: true });
    window.addEventListener('touchstart', handleInteraction, { once: true });

    return () => {
      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };
  }, []);

  // Check rate limiting - max 3 submissions per hour
  const checkRateLimit = () => {
    try {
      const submissions = JSON.parse(localStorage.getItem('formSubmissions') || '[]');
      const now = Date.now();
      const oneHour = 60 * 60 * 1000;

      // Filter submissions from last hour
      const recentSubmissions = submissions.filter(time => now - time < oneHour);

      if (recentSubmissions.length >= 3) {
        return false; // Exceeded rate limit
      }

      // Add current submission
      recentSubmissions.push(now);
      localStorage.setItem('formSubmissions', JSON.stringify(recentSubmissions));
      return true;
    } catch (error) {
      // If localStorage is not available, allow the submission
      return true;
    }
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    // 1. Honeypot check - if filled, it's a bot
    if (website.value !== "") {
      gracias(); // Show success message to fool the bot
      return;
    }

    // 2. Time-based validation - minimum 3 seconds (bots fill forms instantly)
    const timeSinceLoad = (Date.now() - formLoadTime.current) / 1000;
    if (timeSinceLoad < 3) {
      gracias(); // Pretend success but don't send
      return;
    }

    // 3. Interaction check - bots don't move mouse or press keys
    if (!hasInteracted) {
      gracias(); // Pretend success but don't send
      return;
    }

    // 4. Rate limiting check - max 3 submissions per hour
    if (!checkRateLimit()) {
      formButton.innerHTML = "DEMASIADOS INTENTOS";
      formButton.classList.add("btn-fill");
      setTimeout(() => {
        formButton.innerHTML = "CONTÁCTAME";
        formButton.classList.remove("btn-fill");
      }, 3000);
      return;
    }

    if (phone.value.startsWith(1)) {
      return;
    }

    if (name.value == "" || email.value == "") {
      formButton.innerHTML = "INGRESE INFORMACIÓN";
      const inputs = formInputs.elements;

      if (name.value == "") inputs["Nombre"].classList.add("btn-fill");
      if (email.value == "") inputs["Correo"].classList.add("btn-fill");
      formButton.classList.add("btn-fill");
      validate();
    } else {
      sendForm();
    }
  };

  const sendForm = () => {
    const formData = new FormData();
    formData.append("name", name.value);
    formData.append("email", email.value);
    formData.append("phone", phone.value);
    formData.append("mensaje", message.value);
    formData.append("languaje", "es");
    formData.append("section", "contactHome");

    fetch(`${process.env.REACT_APP_URL}/send-contact`, {
      method: "POST",
      body: formData,
    });

    const dataEmail = {
      name: name.value,
      email: email.value,
      section: "contactHome",
    };

    fetch(`${process.env.REACT_APP_SEND_EMAIL_HORIZONTAL}/horizontal-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataEmail),
    }).catch((error) => {
      console.log(error);
    });

    gracias();
  };

  const gracias = () => {
    formButton.innerHTML = "GRACIAS";
    formButton.classList.add("btn-thanks");
    resetForm();
  };

  const resetForm = () => {
    setTimeout(() => {
      const inputs = formInputs.elements;

      formButton.innerHTML = "CONTÁCTAME";
      formButton.classList.remove("btn-thanks");
      formButton.classList.remove("btn-fill");
      inputs["Nombre"].classList.remove("btn-fill");
      inputs["Correo"].classList.remove("btn-fill");
      inputs["Telefono"].classList.remove("btn-fill");
      inputs["Nombre"].value = "";
      inputs["Correo"].value = "";
      inputs["Telefono"].value = "";
    }, 3000);
  };

  const validate = () => {
    setTimeout(() => {
      const inputs = formInputs.elements;

      formButton.innerHTML = "CONTÁCTAME";
      formButton.classList.remove("btn-fill");
      inputs["Nombre"].classList.remove("btn-fill");
      inputs["Correo"].classList.remove("btn-fill");
      inputs["Telefono"].classList.remove("btn-fill");
    }, 3000);
  };

  return (
    <>
      <div className="row no-gutters">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-xs-12">
              <form id="horizontal-form" className="horizontal-form" onSubmit={(e) => handleOnSubmit(e)}>
                <input type="text" name="Nombre" placeholder="Nombre" {...name} />
                <input type="email" name="Correo" placeholder="Correo" {...email} />
                <input type="text" name="Telefono" placeholder="Teléfono (Opcional)" {...phone} />
                {/* Honeypot field - hidden from humans but visible to bots */}
                <input
                  type="text"
                  name="website"
                  placeholder="Website"
                  {...website}
                  style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px' }}
                  tabIndex="-1"
                  autoComplete="off"
                />
                <input type="hidden" value="Español" />
                <button id="horizontal-form__button" type="submit">
                  CONTÁCTAME
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HorizontalFormContact;
